<template>
  <div class="content">
    <form @submit.prevent="submitForm">
      <vue-tel-input
        v-model="phone" 
        :value="phoneNumber"
        mode="international"
        @input="onInput"
        :inputOptions="options"
      ></vue-tel-input>
      <div class="ErrorMessage">
        <p1 v-if="isPhoneNumberValid === false"
          >Please enter a valid phone number!</p1
        >
      </div>
      <br />
      <base-button @click="navigateNextPage">{{$t('proceed')}}</base-button>
    </form>
  </div>
  <div class="pagenumber">
    <label>7/7</label>
  </div>
</template>

<script>
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';

export default {
 
  data() {     
    return {
      phoneNumber: '',
      isPhoneNumberValid: true,
      options: { placeholder: this.$t('phoneNumberRegisteration.phoneNumber') }
    };
  },

  components: {
    VueTelInput,
  },
  methods: {
    navigateNextPage() {
      this.validatePhoneNumber();
      console.log('Is phone number valid:' + this.isPhoneNumberValid);
      console.log('Phone number final:' + this.phoneNumber);
      if (this.isPhoneNumberValid) {
        this.$store.state.phoneNumber = this.phoneNumber;
        this.$router.push('/validaterecaptcha');
      }
    },
    onInput(phone, phoneObject) {
      if (phoneObject?.formatted) {
        this.isPhoneNumberValid = true;
        this.phoneNumber = phoneObject.formatted;
        console.log('Phone:' + this.phoneNumber);
      } 
    },
    validatePhoneNumber(){
      if(this.phoneNumber !== null && this.phoneNumber !== '' && this.phoneNumber !== '+')
        this.isPhoneNumberValid = true;
      else
        this.isPhoneNumberValid = false;
    },
  },
};
</script>

<style scoped>
.vue-tel-input {
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgb(255, 255, 255);
  padding: 1rem 3rem;
  margin: 3rem auto;
  background-color: #eaf8f8;
  font-size: 20px;
  width: 500px;
}
.vue-tel-input.invalid input {
  border-color: rgb(121, 11, 11);
}
</style>
